module.exports = __webpack_public_path__ + "static/media/baug_4.df3c630d.png";